import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import translate from "src/i18n/translate";
export default function OrganizationInsights(_a) {
    var noDataFound = _a.noDataFound;
    return (_jsx("div", { children: _jsxs("div", { className: "page-banner -insights-header insights-header-home", children: [_jsx("h2", { className: "titles", children: "Insights" }), noDataFound ? (_jsx("div", { className: "description", children: translate("app.studentLearningAssessment.welcome") })) : (_jsx("div", { className: "description", children: translate("app.insight.insightProgramDesc") }))] }) }));
}
